/**
 * API client utilities
 */

import { prepareRevisionDependencyForSaving } from '../helpers/revisions';
import { get, put } from '../redux/api';
import { nuc } from '../utils';
import type {
  ListLicensesAPIRequest,
  ListLicensesAPIResponse,
  ReadLicenseAPIResponse,
} from '../../routes/licenses';
import type { UpdateProjectCorrectionRequest } from '../../typings/api';

const getLicenses = async (query: ListLicensesAPIRequest) => {
  const licensesResp = await get<ListLicensesAPIResponse>(
    '/api/licenses',
    false,
    query as Record<string, unknown>,
  );

  return licensesResp?.data;
};

const getLicense = async (id: string) => {
  const licenseResp = await get<ReadLicenseAPIResponse>(`/api/licenses/${id}`);

  return licenseResp?.data;
};

const updateProjectDirectLicenses = (locator, rawLicenses) => {
  const {
    dependencyProjectLocator,
    licenses,
  } = prepareRevisionDependencyForSaving(locator, { licenses: rawLicenses });

  const reqData: UpdateProjectCorrectionRequest = {
    licenses,
  };

  return put(`/api/projects/${nuc(dependencyProjectLocator)}/correction`, reqData);
};

export { getLicenses, getLicense, updateProjectDirectLicenses };
